<template>
  <div class="BaseSearch">
    <div class="search-box">
      <input type="text" class="search-box-inp" v-model="inpVal">
      <button class="search-box-btn" @click="retrieval">搜索</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSearch',
  data() {
    return {
      inpVal: ''
    }
  },
  created() {},
  mounted() {},
  components: {},
  computed: {},
  methods: {
    retrieval() {
      this.$EventBus.$emit('retrievalText', this.inpVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseSearch {
  position: relative;
  // z-index: 999;

  display: flex;
  flex-direction: column;
  gap: 0.52rem;
  justify-content: center;
  align-items: center;

  width: 100%;
  // height: 2.3rem;
  height: auto;
  // margin-top: 1.54rem;
  margin-top: 2.5rem;
  position: relative;
  z-index: 1;

  .search-box {
    position: relative;

    display: flex;

    width: 11rem;
    height: 1rem;
    .search-box-inp {
      width: 9.6rem;
      height: inherit;
      padding: 0.25rem 0.25rem 0.25rem 0.9rem;
      border-radius: 0.15rem 0 0 0.15rem;
      background-color: rgba($color: #000000, $alpha: 0.4);

      color: #fff;
      font-size: 0.4rem;
      font-family: '微软雅黑';
    }

    .search-box-btn {
      width: 1.4rem;
      height: inherit;
      background-color: #caa05a;
      border-radius: 0 0.15rem 0.15rem 0;

      color: #fff;
      font-size: 0.4rem;
      font-family: '微软雅黑';
      text-align: center;
      line-height: 1rem;

      // 
    }
  }
  .search-box::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0.3rem;

    transform: translateY(-50%);

    width: 0.4rem;
    height: 0.4rem;
    background-image: url('~@/assets/img/zsk-search.png');
    background-size: 100% 100%;
  }
}
</style>